module.exports = __webpack_public_path__ + "img/calendar.d2757db1.svg";